import Overlay from 'client/javascript/overlay';
import { showElements } from 'client/javascript/util/dom_utils';

export const OPEN_CONTACT_US_BTN_ID = 'nav-cta-contact-us';
const CLOSE_CONTACT_US_BTN_ID = 'nav-cta-contact-us-close';
const CONTACT_US_OVERLAY_ID = 'contact-us-overlay';
const CONTACT_US_CONTENT_ID = 'contact-us-overlay-content';

let contactUsContentNode;

function setupContactUsEvents(contactUsOverlay) {
  let isOverlayForcedOpen = window.clientSideInjectionVars && window.clientSideInjectionVars.showContactUsOnLoad;

  const openContactUsBtn = document.getElementById(OPEN_CONTACT_US_BTN_ID);
  const closeContactUsBtn = document.getElementById(CLOSE_CONTACT_US_BTN_ID);

  closeContactUsBtn.addEventListener('click', contactUsOverlay.close);

  if (openContactUsBtn) {
    openContactUsBtn.addEventListener('click', event => {
      contactUsOverlay.open(event, () => showElements(contactUsContentNode));
    });

    if (isOverlayForcedOpen) {
      contactUsOverlay.open(undefined, () => showElements(contactUsContentNode));
      isOverlayForcedOpen = !isOverlayForcedOpen;
    }
  }
}

export function setUpContactUsOverlay() {
  contactUsContentNode = document.getElementById(CONTACT_US_CONTENT_ID);

  const contactUsOverlay = new Overlay(CONTACT_US_OVERLAY_ID, { excludeCloseButton: true });
  contactUsOverlay.addContent(contactUsContentNode);

  setupContactUsEvents(contactUsOverlay);
}
